import {
    FaMapMarkerAlt,
    FaPhoneAlt,
    FaEnvelope,
    FaClock
  } from "react-icons/fa";
  
  const info = [
    
    {
      icon: <FaPhoneAlt />,
      title: "Phone",
      text: "+44 751 586 6571"
    },
    {
      icon: <FaEnvelope />,
      title: "Email",
      text: "contact@relyonneuk.com"
    },
    {
      icon: <FaClock />,
      title: "Business Hours",
      text: "Mon - Fri | 9:00 AM - 6:00 PM"
    }
  ];
  
  export default function ContactInfo() {
    return (
      <section className="contact-info">
  
        <h2>Get In Touch</h2>
  
        <div className="contact-grid">
  
          {info.map((item, index) => (
  
            <div className="contact-card" key={index}>
  
              <div className="contact-icon">
                {item.icon}
              </div>
  
              <h4>{item.title}</h4>
  
              <p>{item.text}</p>
  
            </div>
  
          ))}
  
        </div>
  
      </section>
    );
  }